import { AnimatedContentLoader } from '@root/components'
import { FaUniversity } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

import VerohallintoSettingsAlert from './VerohallintoSettingsAlert'
import VerohallintoSettingsForm from './VerohallintoSettingsForm'
import { useVerohallintoCertificateStatus } from '@root/query/hooks'
import { SettingsDataCard } from '@pages/SettingsPage/components/SettingsDataCard'
import { SettingsSubPageLayout } from '@pages/SettingsPage/components/SettingsSubPageLayout'

const VerohallintoSettings: React.FC = () => {
  const [t] = useTranslation()
  const { isLoading, isError } = useVerohallintoCertificateStatus()

  return (
    <SettingsSubPageLayout title={t('settings.verohallintoSettings.header')}>
      <StyledContentWrapper>
        <AnimatedContentLoader
          isLoading={isLoading}
          isError={isError}
          errorDescription={t('error.oho')}
        >
          <VerohallintoSettingsAlert />
          <SettingsDataCard
            icon={<FaUniversity />}
            title={t('settings.verohallintoSettings.formTitle')}
            body={<VerohallintoSettingsForm />}
          />
        </AnimatedContentLoader>
      </StyledContentWrapper>
    </SettingsSubPageLayout>
  )
}

export default VerohallintoSettings

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
`
